import orderBy from 'lodash.orderby';
import ColorHash from 'color-hash';

import {isLightColor} from '@/utils';

import API from '@/api';

const colorHash = new ColorHash({
  lightness: 0.85,
});

export function getTagColor(tag) {
  if (tag.color) {
    return tag.color;
  }
  // No custom color defined yet? Fallback to color hash of name.
  return colorHash.hex(tag.name);
}

export function getTagTextColor(tag) {
  const backgroundColor = getTagColor(tag);
  return isLightColor(backgroundColor) ? '#000000' : '#ffffff';
}

// Spot
export function addTagToSpot(tag, spot) {
  for (const existingTag of spot.tags) {
    if (existingTag.id === tag.id) {
      return;
    }
  }
  spot.tags.push(tag);

  return API.addTagToSpot(spot.ident, tag.id);
}

export function removeTagFromSpot(tag, spot) {
  const index = spot.tags.findIndex((t) => t.id === tag.id);
  if (index >= 0) {
    spot.tags.splice(index, 1);
  }

  return API.removeTagFromSpot(spot.ident, tag.id);
}

// Decoder
export function addTagToDecoder(tag, decoder, sortByName = true) {
  for (const existingTag of decoder.tags) {
    if (existingTag.id === tag.id) {
      return;
    }
  }
  decoder.tags.push(tag);
  if (sortByName) {
    decoder.tags = orderBy(decoder.tags, [(tag) => tag.name.toLowerCase()]);
  }

  return API.addTagToDecoder(decoder.ident, tag.id);
}

export function removeTagFromDecoder(tag, decoder) {
  const index = decoder.tags.findIndex((t) => t.id === tag.id);
  if (index >= 0) {
    decoder.tags.splice(index, 1);
  }

  return API.removeTagFromDecoder(decoder.ident, tag.id);
}

export default {
  methods: {
    getTagColor: getTagColor,
    getTagTextColor: getTagTextColor,
  },
};



// WEBPACK FOOTER //
// ./src/mixins/tags.js